import React, { useMemo } from 'react';
import { Select } from 'antd';

interface BidhiMetadataTagsSelectProps {
  value?: string[];
  onChange?: (value: string[]) => void;
  tagOptions: string[];
}

const BidhiMetadataTagsSelect: React.FC<BidhiMetadataTagsSelectProps> = ({
  value,
  onChange,
  tagOptions,
}) => {
  const options = useMemo(
    () => tagOptions.map((tag) => ({ value: tag, label: tag })),
    [tagOptions],
  );

  return (
    <Select
      mode="tags"
      showSearch
      value={value}
      onChange={onChange}
      placeholder="Select or type tags"
      style={{ width: '100%' }}
      tokenSeparators={[',']}
      options={options}
      filterOption={(input, option) =>
        String(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
    />
  );
};

export default BidhiMetadataTagsSelect;